var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addIframeWidth"},[_c('iframe',{attrs:{"id":"iframe","src":_vm.srcUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }